import { render, staticRenderFns } from "./FixedMatterInformationTab.vue?vue&type=template&id=455328ef&"
import script from "./FixedMatterInformationTab.vue?vue&type=script&lang=ts&"
export * from "./FixedMatterInformationTab.vue?vue&type=script&lang=ts&"
import style0 from "./FixedMatterInformationTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports